(function () {
  'use strict';
  if (window.FWTWheelData) return;
  var KEY = 'fwtWheels:v2:';
  var TTL = 20 * 60 * 1000;
  var pending = {};

  function num(s) { var n = parseFloat(s); return isNaN(n) ? null : n; }
  function trimNum(n) { return String(Math.round(n * 100) / 100); }

  function parseSize(title) {
    var s = String(title || '').replace(/\([^)]*\)/g, ' ').replace(/\bETA\b.*$/i, ' ').replace(/\s+/g, ' ').trim();
    var m = /(^|\s)(\d{2})(?:\.\d)?\s*[xX]\s*(\d{1,2}(?:\.\d{1,2})?)J?(?=\s|$|\/)/.exec(s);
    if (!m) return null;
    var rim = parseInt(m[2], 10), width = num(m[3]);
    if (rim < 12 || rim > 26 || width === null || width < 3 || width > 16) return null;
    var rest = (s.slice(0, m.index) + ' ' + s.slice(m.index + m[0].length)).trim();
    var pcd = [], seen = {};
    rest = rest.replace(/\b([3-8])\s*[xX]\s*(\d{3}(?:\.\d{1,2})?)\b/g, function (all, lugs, dia) {
      var p = lugs + 'x' + trimNum(num(dia));
      if (!seen[p]) { seen[p] = 1; pcd.push(p); }
      return ' ';
    });
    var off = null;
    var om = /(?:^|[\s\/])(?:ET\s*)?([+-]?\d{1,3})(?=\s|$)/i.exec(rest.replace(/\//g, ' '));
    if (om) { var o = parseInt(om[1], 10); if (o >= -100 && o <= 150) off = o; }
    var label = rim + 'x' + trimNum(width) + (pcd.length ? ' ' + pcd.join('/') : '') + (off !== null ? ' ' + (off > 0 ? '+' + off : String(off)) : '');
    return { rim: rim, w: trimNum(width), pcd: pcd, off: off, label: label };
  }

  var OFFSETS = [
    ['neg', 'Negative (below 0)', function (o) { return o < 0; }],
    ['0-19', '0 to +19', function (o) { return o >= 0 && o <= 19; }],
    ['20-34', '+20 to +34', function (o) { return o >= 20 && o <= 34; }],
    ['35-up', '+35 and higher', function (o) { return o >= 35; }]
  ];

  function offsetBand(o) {
    if (o === null || o === undefined) return null;
    for (var i = 0; i < OFFSETS.length; i++) if (OFFSETS[i][2](o)) return OFFSETS[i][0];
    return null;
  }

  function build(rows) {
    var products = [];
    rows.forEach(function (r) {
      var p = { h: r[0], t: r[1], b: r[2], img: r[3] || '', v: [] };
      (r[4] || []).forEach(function (x) {
        var z = parseSize(x[1]);
        if (!z) return;
        p.v.push({ id: x[0], title: x[1], rim: z.rim, w: z.w, pcd: z.pcd, off: z.off, band: offsetBand(z.off), label: z.label, p: x[2], c: x[3] || 0, a: !!x[4] });
      });
      if (p.v.length) products.push(p);
    });
    return products;
  }

  function getPage(base, n) {
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return fetch(base + sep + 'view=fwt-wheel-data&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  function load(base) {
    base = base.replace(/\/$/, '');
    if (pending[base]) return pending[base];
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY + base) || 'null');
      if (c && c.at && Date.now() - c.at < TTL && c.rows) { pending[base] = Promise.resolve(build(c.rows)); return pending[base]; }
    } catch (e) {}
    pending[base] = getPage(base, 1).then(function (first) {
      var jobs = [];
      for (var n = 2; n <= Math.min(first.pages || 1, 12); n++) jobs.push(getPage(base, n));
      return Promise.all(jobs).then(function (rest) {
        var rows = first.p || [];
        rest.forEach(function (x) { rows = rows.concat(x.p || []); });
        try { sessionStorage.setItem(KEY + base, JSON.stringify({ at: Date.now(), rows: rows })); } catch (e) {}
        return build(rows);
      });
    });
    pending[base].catch(function () { delete pending[base]; });
    return pending[base];
  }

  function matches(v, sel, skip) {
    if (!v.a) return false;
    if (sel.rim && skip !== 'rim' && String(v.rim) !== String(sel.rim)) return false;
    if (sel.w && skip !== 'w' && v.w !== String(sel.w)) return false;
    if (sel.pcd && skip !== 'pcd' && v.pcd.indexOf(sel.pcd) < 0) return false;
    if (sel.off && skip !== 'off' && v.band !== sel.off) return false;
    if (skip !== 'off' && v.off !== null && (sel.omin !== undefined && sel.omin !== '' && v.off < +sel.omin)) return false;
    if (skip !== 'off' && v.off !== null && (sel.omax !== undefined && sel.omax !== '' && v.off > +sel.omax)) return false;
    return true;
  }

  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function describe(sel) {
    var bits = [];
    if (sel.rim) bits.push(sel.rim + '" rim');
    if (sel.w) bits.push(sel.w + '" wide');
    if (sel.pcd) bits.push(sel.pcd);
    if (sel.off) { var o = OFFSETS.filter(function (x) { return x[0] === sel.off; })[0]; if (o) bits.push('offset ' + o[1].toLowerCase()); }
    if (!sel.off && sel.omin !== undefined && sel.omin !== '' && sel.omax !== undefined && sel.omax !== '') bits.push('offset ' + sel.omin + ' to ' + sel.omax);
    return bits.join(', ');
  }

  window.FWTWheelData = { load: load, parseSize: parseSize, matches: matches, offsets: OFFSETS, money: money, describe: describe };
})();
